module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('editor', {
    ref: "editor",
    attrs: {
      "init": _vm.simple ? _vm.simpleEditorInit : _vm.editorInit,
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }), _vm._v(" "), _c('photos-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "cancel": _vm.dialogCancelled,
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "file-dialog",
    attrs: {
      "title": "Wgraj plik",
      "width": "408px",
      "top": "0",
      "center": "",
      "append-to-body": "",
      "visible": _vm.innerVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      }
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "",
      "show-file-list": false,
      "http-request": _vm.sendFile
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n                Przeciągnij i upuść plik, lub "), _c('em', [_vm._v("kliknij tutaj")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "existing-button"
  }, [_c('el-button', {
    staticClass: "open-dialog-button",
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.openPhotosDialog
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" Wybierz z istniejących\n            ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.innerVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.innerVisible = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7d8a008"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WyswigInput.vue
// module id = 804
// module chunks = 0